var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 187.6 30.9",
    style: {
      enableBackground: "new 0 0 187.6 30.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF4820;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.5,6.1H0V0.5h26v5.6h-9.5v24.2H9.5V6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.1,0.5v29.8h-6.9V18.1H36.6v12.2h-6.9V0.5h6.9v11.8h13.6V0.5H57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.2,24.8v5.5H64.1V0.5h22.5v5.5H71v6.5h13.8v5.4H71v6.9H87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.8,15h6.3v12.1c-1.6,1.2-3.5,2.2-5.6,2.8c-2.1,0.7-4.3,1-6.4,1c-3.1,0-5.9-0.7-8.3-2 c-2.5-1.3-4.4-3.2-5.8-5.5c-1.4-2.3-2.1-5-2.1-7.9c0-3,0.7-5.6,2.1-7.9c1.4-2.3,3.4-4.2,5.9-5.5c2.5-1.3,5.3-2,8.4-2 c2.6,0,5,0.4,7.1,1.3c2.1,0.9,3.9,2.2,5.4,3.8l-4.4,4.1c-2.1-2.2-4.7-3.4-7.7-3.4c-1.9,0-3.6,0.4-5.1,1.2C101,7.9,99.8,9,99,10.4 c-0.8,1.4-1.2,3.1-1.2,5c0,1.8,0.4,3.5,1.2,4.9c0.8,1.4,2,2.6,3.4,3.4c1.5,0.8,3.1,1.2,5,1.2c2,0,3.8-0.4,5.4-1.3V15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.8,19.8v10.6h-6.9V19.7L121.4,0.5h7.3l8,13.3l8-13.3h6.8L139.8,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.1,30.3l0-17.9l-8.8,14.7h-3.1l-8.7-14.4v17.5H154V0.5h5.7L170.9,19l11-18.5h5.7l0.1,29.8H181.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.85dfd8e1232126d868534de55c5a0a7a.svg";
export { ForwardRef as ReactComponent };